import {NgModule} from '@angular/core';

import {MzParallaxComponent} from './parallax.component';

@NgModule({
  declarations: [MzParallaxComponent],
  exports: [MzParallaxComponent],
})
export class MzParallaxModule {
}
